export const MIN_PROFILE_SIZE_FOR_BADGE = 50;

export const MODES = {
    STANDARD: 'standard',
    VIDEO_INTENT: 'video_intent'
};
